export function createDefaultECGViewState(args) {
    return {
        timeRange: [...args.timeRange],
        valueRange: [...args.valueRange],
        scrollOffset: 0,
        anchorCanvas: [0.5, 0.5],
        scale: 1,
        scaleMode: 'fit',
        rotation: 0,
    };
}
export function normalizeECGViewState(camera) {
    return {
        timeRange: [...camera.timeRange],
        valueRange: [...camera.valueRange],
        ...(camera.scrollOffset !== undefined
            ? { scrollOffset: camera.scrollOffset }
            : {}),
        anchorCanvas: cloneAnchorCanvas(camera.anchorCanvas ?? [0.5, 0.5]),
        scale: Math.max(camera.scale ?? 1, 0.001),
        scaleMode: 'fit',
        rotation: 0,
        ...(camera.anchorWorld
            ? {
                anchorWorld: clonePoint(camera.anchorWorld),
            }
            : {}),
    };
}
export function resolveECGCanvasMapping(args) {
    const { metrics, camera, canvas } = args;
    const scale = Math.max(camera?.scale ?? 1, 0.001);
    const effectiveRatio = metrics.worldToCanvasRatio * scale;
    const drawWidth = metrics.ecgWidth * effectiveRatio;
    const drawHeight = metrics.ecgHeight * effectiveRatio;
    const centeredXOffset = (canvas.clientWidth - drawWidth) / 2;
    const centeredYOffset = (canvas.clientHeight - drawHeight) / 2;
    const anchorCanvas = cloneAnchorCanvas(camera?.anchorCanvas ?? [0.5, 0.5]);
    const anchorWorld = clonePoint(camera?.anchorWorld) ??
        [metrics.ecgWidth / 2, metrics.ecgHeight / 2];
    const xOffset = canvas.clientWidth * anchorCanvas[0] - anchorWorld[0] * effectiveRatio;
    const yOffset = canvas.clientHeight * anchorCanvas[1] - anchorWorld[1] * effectiveRatio;
    return {
        anchorWorld,
        anchorCanvas,
        canvasHeight: canvas.clientHeight,
        canvasWidth: canvas.clientWidth,
        centeredXOffset,
        centeredYOffset,
        effectiveRatio,
        xOffset,
        yOffset,
    };
}
export function getPanForECGCanvasMapping(mapping) {
    return [
        mapping.xOffset - mapping.centeredXOffset,
        mapping.yOffset - mapping.centeredYOffset,
    ];
}
export function getAnchorWorldForPan(pan, mapping) {
    return [
        (mapping.canvasWidth * mapping.anchorCanvas[0] -
            (mapping.centeredXOffset + pan[0])) /
            mapping.effectiveRatio,
        (mapping.canvasHeight * mapping.anchorCanvas[1] -
            (mapping.centeredYOffset + pan[1])) /
            mapping.effectiveRatio,
    ];
}
export function getAnchorWorldForCanvasPoint(canvasPoint, mapping) {
    return [
        (canvasPoint[0] - mapping.xOffset) / mapping.effectiveRatio,
        (canvasPoint[1] - mapping.yOffset) / mapping.effectiveRatio,
    ];
}
function clonePoint(point) {
    return point ? [point[0], point[1]] : undefined;
}
function cloneAnchorCanvas(anchorCanvas) {
    return [anchorCanvas[0], anchorCanvas[1]];
}
